import { Tooltip } from '@material-ui/core';
import { Theme, createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { Funding } from '@fluentsms/agentnet-web-icons';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { REMITTANCE_BASIS_TOOLTIP } from 'features/constants';
import { numberValueFormatter } from './reportsListConfig';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconSpacing: {
      display: 'flex',
      marginLeft: theme.spacing(1),
    },
  }),
);

const GrossRenderer = (params: ICellRendererParams) => {
  const classes = useStyles();
  const theme = useTheme();
  const formattedGross = numberValueFormatter(params);

  if (!params?.data?.isRemittanceBasisRate) {
    return <span>{formattedGross}</span>;
  }

  const remittanceTooltip = REMITTANCE_BASIS_TOOLTIP(numberValueFormatter(params.data.remittanceBasisAmount, true));

  return (
    <div className="d-flex-center">
      {formattedGross}
      <Tooltip title={remittanceTooltip} placement="right" arrow>
        <span className={classes.iconSpacing}>
          <Funding fill={theme.palette.brand.welcome} width={16} height={20} data-testid="remittance-basis-indicator" />
        </span>
      </Tooltip>
    </div>
  );
};

export default GrossRenderer;
